import { Route, usePostLoginRoute } from '../../config/router'
import { ConsumerAccountResponse } from '../../model'
import { captureCashConsent, useAppDispatch, useAppRouter, useIsCashApp } from '../../state'
import { phoneNumberIsCleared } from '../../utils/phone-numbers'
import { markInteractiveLogin } from '../remember-me/loginSignal'

export const useContinueAfterSignIn = (): ((account: ConsumerAccountResponse) => Promise<void>) => {
  const router = useAppRouter()
  const dispatch = useAppDispatch()
  const postLoginRoute = usePostLoginRoute()
  const isCashApp = useIsCashApp()

  return async (account) => {
    if (postLoginRoute === Route.LOGGED_IN) {
      markInteractiveLogin()
    }
    if (!account.profileConfirmed) {
      router.push(Route.SIGN_UP)
      return
    }
    if (isCashApp) {
      dispatch(captureCashConsent())
    }
    if (phoneNumberIsCleared(account.phoneNumber ?? '')) {
      router.push(Route.ADD_MOBILE)
    } else {
      router.replace(postLoginRoute, account.preferredLocale)
    }
  }
}
